<template>
  <f7-popup class="popup-anular-directo" :opened="opened" @popup:opened="abrir" @popup:closed="$emit('cerrar')">
    <f7-page v-if="solicitud">
      <f7-navbar :title="$t('anularVacaciones.anularTitulo', { quien: nombre })">
        <f7-nav-right>
          <f7-link popup-close>{{ $t('cerrar') }}</f7-link>
        </f7-nav-right>
      </f7-navbar>

      <f7-block strong class="cabecera">
        <div class="cabecera-tramo">{{ solicitud.codigo }} · {{ fechasDe(solicitud) }}</div>
        <div class="cabecera-nota">{{ $t('anularVacaciones.soloFuturos') }}</div>
      </f7-block>

      <!-- Esto quita días del calendario de otra persona sin que ella lo haya pedido, así que se
           dice en grande antes de los campos. -->
      <f7-block strong class="aviso aviso-error">
        <p>{{ $t('anularVacaciones.avisoDirecta', { quien: nombre }) }}</p>
      </f7-block>

      <f7-block-title>{{ $t('anularVacaciones.diasAAnular') }}</f7-block-title>
      <f7-block strong class="dias">
        <label
          v-for="dia in solicitud.dias"
          :key="dia"
          class="dia"
          :class="{ 'dia-pasado': !esAnulable(dia) }"
        >
          <input
            type="checkbox"
            :checked="elegidos.indexOf(dia) >= 0"
            :disabled="!esAnulable(dia)"
            @change="alternar(dia, $event.target.checked)"
          />
          <span class="dia-fecha">{{ corta(dia) }}</span>
          <span v-if="!esAnulable(dia)" class="dia-motivo">{{ $t('anularVacaciones.yaPasado') }}</span>
        </label>
        <p v-if="!solicitud.dias.length" class="vacio">{{ $t('anularVacaciones.sinDias') }}</p>
      </f7-block>

      <f7-block v-if="!elegidos.length" strong class="aviso aviso-error">
        <p>{{ $t('anularVacaciones.eligeAlgunDia') }}</p>
      </f7-block>

      <!-- El tipo es una lista CERRADA y la sirve el servidor: no hay «otro» escrito a mano. Si la
           lista no se ha podido leer se dice y se puede reintentar, en vez de dejar un desplegable
           vacío con el que no se puede anular y sin explicar por qué.
           Son TRES estados y no dos: mientras la petición está en vuelo la lista también está
           vacía, y leer ahí el error es leer un fallo que no ha pasado. -->
      <f7-block-title>{{ $t('anularVacaciones.tipoObligatorio') }}</f7-block-title>
      <f7-block strong>
        <template v-if="tipos.length">
          <select class="tipo" :value="tipo" @change="tipo = $event.target.value">
            <option value="">{{ $t('anularVacaciones.eligeTipo') }}</option>
            <option v-for="t in tipos" :key="t.codigo" :value="t.codigo">{{ t.etiqueta }}</option>
          </select>
          <!-- Lo que cambia la «incapacidad temporal» respecto a los demás tipos, dicho donde se
               elige: sus días no caducan el 31 de marzo (art. 38.3 del Estatuto). -->
          <p v-if="tipo === 'INCAPACIDAD_TEMPORAL'" class="nota-it">
            {{ $t('anularVacaciones.notaIncapacidad') }}
          </p>
        </template>
        <p v-else-if="cargandoTipos" class="cargando-tipos">
          {{ $t('anularVacaciones.cargandoTipos') }}
        </p>
        <template v-else>
          <p class="error-tipos">{{ $t('anularVacaciones.errorTipos') }}</p>
          <f7-link @click="cargarTipos">{{ $t('anularVacaciones.reintentarTipos') }}</f7-link>
        </template>
      </f7-block>

      <f7-block-title>{{ $t('anularVacaciones.motivoObligatorio') }}</f7-block-title>
      <f7-block strong>
        <textarea
          class="motivo"
          rows="3"
          :value="motivo"
          :placeholder="$t('anularVacaciones.motivoDirectaPlaceholder')"
          @input="motivo = $event.target.value"
        ></textarea>
        <!-- El recordatorio de que aquí NO va un diagnóstico. El campo es el motivo de la
             anulación, y con «incapacidad temporal» es justo donde podría colarse un dato de salud
             que nadie ha pedido: ni se pide ni se guarda. -->
        <p class="nota-sin-diagnostico">{{ $t('anularVacaciones.sinDiagnostico') }}</p>
      </f7-block>

      <!-- Si hay una petición esperando sobre esta solicitud, anular directamente la cierra. Se
           dice antes de pulsar: quien la pidió va a recibir un aviso que no esperaba. -->
      <f7-block v-if="hayPeticionPendiente" strong class="aviso aviso-naranja">
        <p>{{ $t('anularVacaciones.cerraraLaPeticion') }}</p>
      </f7-block>

      <f7-block strong class="pie">
        <!-- Por qué no se puede anular, pegado al botón. El aviso de arriba solo cubre los días:
             sin tipo o sin motivo, el botón se quedaba gris sin que nada lo explicara, y eso es lo
             que dirección prohibió el 05/10 («un control que no se puede usar dice por qué, quién
             lo desbloquea y dónde»). Se enumera TODO lo que falta en vez de lo primero que falle:
             así no hay que rellenar un campo para enterarse de que falta otro. -->
        <span v-if="!puedeAnular" class="falta">{{ loQueFalta }}</span>
        <span class="botones">
          <f7-button :text="$t('anularVacaciones.volver')" class="display-flex" @click="$emit('cerrar')"></f7-button>
          <f7-button
            fill
            color="red"
            :text="$t('anularVacaciones.anular')"
            :disabled="!puedeAnular"
            class="display-flex"
            @click="anular"
          ></f7-button>
        </span>
      </f7-block>
    </f7-page>
  </f7-popup>
</template>
<style scoped>
.cabecera { background-color: #eef6ff; border-left: 4px solid #2196f3; }
.cabecera-tramo { font-size: 15px; font-weight: bold; color: #11508c; }
.cabecera-nota { font-size: 12px; color: #11508c; margin-top: 2px; }

.dias { display: flex; flex-wrap: wrap; gap: 8px; padding: 10px; }
.dia {
  display: flex;
  align-items: center;
  gap: 6px;
  border: 1px solid #c8c9cc;
  border-radius: 4px;
  padding: 4px 8px;
  font-size: 13px;
  background-color: #fff;
}
.dia-fecha { font-weight: bold; color: #1a2744; }
.dia-pasado { background-color: #f4f5f7; color: #8e8e93; }
.dia-pasado .dia-fecha { color: #8e8e93; text-decoration: line-through; font-weight: normal; }
.dia-motivo { font-size: 11px; color: #8e8e93; }

.tipo {
  width: 100%;
  box-sizing: border-box;
  border: 1px solid #c8c9cc;
  border-radius: 4px;
  padding: 6px 8px;
  font-size: 14px;
  background-color: #fff;
}
.nota-it { font-size: 12px; color: #11508c; margin: 6px 0 0; }
.error-tipos { font-size: 13px; color: #8a1c13; margin: 0 0 4px 0; }
/* Gris de la guía, no rojo: esperar no es un fallo. */
.cargando-tipos { font-size: 13px; color: #6d6d72; margin: 0; }

.motivo {
  width: 100%;
  box-sizing: border-box;
  border: 1px solid #c8c9cc;
  border-radius: 4px;
  padding: 6px 8px;
  font-size: 14px;
  font-family: inherit;
}
.nota-sin-diagnostico { font-size: 11px; color: #8e8e93; margin: 6px 0 0; }

.aviso { border-left: 4px solid #cfd4da; }
.aviso p { margin: 3px 0; font-size: 13px; }
.aviso-error { background-color: #fdecea; border-left-color: #d9534f; color: #8a1c13; }
.aviso-naranja { background-color: #fff4e5; border-left-color: #f0a000; color: #8a4b00; }

.pie { display: flex; justify-content: flex-end; align-items: center; flex-wrap: wrap; gap: 8px; }
.falta { font-size: 12px; color: #8a1c13; margin-right: auto; }
.botones { display: flex; gap: 8px; }
.vacio { font-size: 13px; color: #8e8e93; margin: 0; }
</style>
<script>
import RhBandejaVacaciones, { EVENTO_VACACIONES_RESUELTA } from "./../../js/db/RhBandejaVacaciones.js";
import mensajeDelServidor from "./../../js/utils/mensajeDelServidor.js";
import { EventBus } from "./../../js/EventBus.js";
import textoDeLasFechas from "./../../js/utils/tramosSolicitud.js";
import accionDeLaSesion from "./../../js/utils/accionDeLaSesion.js";
import identidadSesion, { sigueLaSesion } from "./../../js/utils/identidadSesion.js";
import { unaAccionALaVez, claveDeSolicitud } from "./../../js/utils/unaAccionALaVez.js";
import soloMandaLaDeDelante, {
  MOTIVO_CIERRE_DE_SESION, selloDeLaVentana, alDejarDeMandar, soloMandaLaVentanaDeAhora
} from "./../../js/utils/soloMandaLaDeDelante.js";

/**
 * Ventana «Anular vacaciones» del aprobador (#69, punto 3): quitar días de unas vacaciones ya
 * confirmadas **sin que la persona lo haya pedido**, con tipo y motivo.
 *
 * **Nunca se pide un diagnóstico.** El tipo «incapacidad temporal» dice que hubo una baja y nada
 * más: no hay campo para el parte ni para la dolencia, y el motivo que se escribe es el de la
 * anulación. El texto de debajo del motivo lo dice, porque es justo ahí donde podría colarse.
 *
 * Como en las demás pantallas del módulo, **aquí no se decide nada**: qué días se pueden anular lo
 * dice el servidor (`diasAnulables`), la lista de tipos la sirve él y las validaciones las rehace
 * al recibir. Lo único que se decide en la pantalla es cuándo se puede pulsar el botón.
 */
export default {
  // Las mismas tres piezas que «Pedir anulación», y por lo mismo: esta ventana ESCRIBE, y una
  // escritura del módulo va atada a su sesión, a su pantalla, a la solicitud con la que se abrió
  // la ventana y al cerrojo de esa solicitud. Ver el comentario de `anular` y el de
  // `pedir-anulacion.vue`.
  mixins: [soloMandaLaDeDelante, soloMandaLaVentanaDeAhora, unaAccionALaVez],
  props: {
    opened: { type: Boolean, default: false },
    /** La solicitud que se va a anular, tal como la trae la bandeja. */
    solicitud: { type: Object, default: null }
  },
  data: function() {
    return {
      elegidos: [],
      tipo: '',
      motivo: '',
      /** La lista cerrada, que trae el servidor. Vacía y sin carga en vuelo = no se pudo leer. */
      tipos: [],
      /**
       * Si la lista está en camino. Separa «todavía no ha llegado» de «no se ha podido leer»: sin
       * esto, la primera apertura enseñaba el error mientras esperaba la respuesta.
       */
      cargandoTipos: false
    };
  },
  computed: {
    /**
     * **De qué solicitud es esta ventana ahora mismo**, para `soloMandaLaVentanaDeAhora`: la
     * instancia es una sola y la pantalla la reutiliza, así que esto es lo que distingue una
     * apertura de la siguiente y lo que descarta los efectos de la anterior.
     */
    sujetoDeLaVentana: function() {
      return (this.solicitud && this.solicitud.id) || null;
    },
    nombre: function() {
      const s = this.solicitud;
      return (s && (s.nombre || s.username)) || '';
    },
    anulables: function() {
      return (this.solicitud && this.solicitud.diasAnulables) || [];
    },
    hayPeticionPendiente: function() {
      const p = this.solicitud && this.solicitud.peticionAnulacion;
      return !!(p && p.estado === 'PENDIENTE');
    },
    puedeAnular: function() {
      return this.elegidos.length > 0 && !!this.tipo && !!this.motivo.trim() && !this.enVuelo;
    },
    /**
     * Si ya se está resolviendo esa solicitud. Es el cerrojo del módulo y es de la solicitud, así
     * que también vale si lo que viaja salió de la bandeja: anular y aceptar la anulación son dos
     * resoluciones de lo mismo con la misma `version`, y la segunda acabaría enseñando un conflicto
     * después del aviso de que había ido bien.
     */
    enVuelo: function() {
      return !!this.solicitud && this.accionEnVueloSobre(claveDeSolicitud(this.solicitud.id));
    },
    /**
     * Lo que le falta al botón, con las mismas condiciones de `puedeAnular` y en el mismo orden.
     * Quien añada una condición a `puedeAnular` añade aquí su línea: es el precio de que el botón
     * no se quede mudo.
     *
     * El tipo tiene DOS motivos distintos para faltar y no se cuentan igual: que no se haya
     * elegido —lo arregla quien está delante— o que la lista no se haya podido leer, que ya se
     * dice arriba con su enlace de reintentar y no lo arregla rellenando nada.
     */
    loQueFalta: function() {
      // La anulación en vuelo va primero y corta: no falta nada que rellenar, y lo desbloquea el
      // servidor al contestar.
      if (this.enVuelo) return this.$t('anularVacaciones.enVuelo');
      const falta = [];
      const sinLista = !this.tipo && !this.tipos.length && !this.cargandoTipos;
      if (!this.elegidos.length) falta.push(this.$t('anularVacaciones.faltaDias'));
      if (!this.tipo) {
        falta.push(this.$t(sinLista ? 'anularVacaciones.faltaTipos' : 'anularVacaciones.faltaTipo'));
      }
      if (!this.motivo.trim()) falta.push(this.$t('anularVacaciones.faltaMotivo'));
      if (!falta.length) return '';
      // Y quién lo desbloquea cambia con el motivo: lo que falta por rellenar lo pone quien está
      // delante, pero una lista que no se ha podido leer no se arregla escribiendo nada.
      return this.$t(sinLista ? 'anularVacaciones.faltaPorFallo' : 'anularVacaciones.faltaPara', {
        que: falta.join(this.$t('anularVacaciones.faltaY'))
      });
    }
  },
  methods: {
    /** Cada apertura empieza de cero: la ventana vive en una pantalla con `keepAlive`. */
    abrir: function() {
      this.elegidos = this.anulables.slice();
      this.tipo = '';
      this.motivo = '';
      if (!this.tipos.length) this.cargarTipos();
    },
    /**
     * La lista de tipos. Se pide al abrir y no al construir la ventana porque la pantalla se monta
     * una vez y puede no abrirse nunca; y si falla, no se tumba nada: se dice y se puede reintentar
     * desde el enlace.
     *
     * Una sola petición en vuelo: el enlace de reintentar está visible mientras se espera en el
     * resto de la familia —en una conexión lenta se pulsa— y dos respuestas a destiempo pueden
     * dejar la lista con la de la petición que falló.
     *
     * ## Y de qué sesión es esta consulta
     *
     * Es la única LECTURA de las dos ventanas de la #69, y le faltaba lo que sus escrituras ya
     * tienen por `accionDeLaSesion`: saber de quién era. Con `keepAlive` la instancia sobrevive al
     * cierre de sesión, así que la respuesta de una cuenta llegaba sobre la siguiente y repoblaba
     * la lista que `dejarDeMandar` acababa de tirar —y entonces `abrir()` la veía llena y ya no
     * preguntaba por la sesión nueva—; su error la volvía a vaciar; y su `then` final apagaba el
     * «cargando» de la consulta de al lado. Y al revés: si no contestaba nunca, `cargandoTipos`
     * se quedaba puesto, `cargarTipos` salía de vuelta en el `if` de arriba y la ventana se
     * quedaba en «cargando…» hasta recargar la pantalla (revisión CODEX del PR #1748, ronda 7).
     *
     * Por eso las guardas van **dentro de los tres eslabones** y no envolviendo la promesa: el
     * `catch` y el cierre son justo los dos que seguían actuando sobre la ventana nueva.
     *
     * Se preguntan las dos cosas, como en `accionDeLaSesion`: el **token**, porque es lo que viajó
     * en la petición y se puede comprobar sin depender de haber recibido el aviso del cierre; y el
     * **sello de la ventana**, porque sin él volver a entrar —con la misma cuenta o con otra— no
     * descartaría nada en el hueco en que el token todavía coincide. El de la ventana y no el de la
     * pantalla: esta lista es de este desplegable, así que cerrarla también la descarta.
     *
     * Esto NO cierra la familia entera: las demás lecturas del módulo se protegen por sus carriles
     * y la pieza común que las cubriría a todas es la decisión técnica de Donchurru del 19/10/2026,
     * que va en la **#663**. Aquí se arregla esta ventana, que es lo autorizado.
     */
    cargarTipos: function() {
      const self = this;
      if (self.cargandoTipos) return;
      // De quién y de dónde es, tomado ANTES de pedir: es el único momento en el que la respuesta
      // es con seguridad de quien está delante.
      const deLaSesion = identidadSesion();
      const sigueDelante = selloDeLaVentana(self);
      const sigueSiendoMia = function() {
        return sigueLaSesion(deLaSesion) && sigueDelante();
      };
      self.cargandoTipos = true;
      // La espera se suelta al salir **sin esperar a nadie**, porque esta consulta puede no
      // contestar nunca: preguntar al volver solo sirve si vuelve. Es el mismo reparto que hace
      // `preloaderDeLaSesion` con el indicador de espera, y las tres salidas siguen enumeradas en
      // un solo sitio (`soloMandaLaDeDelante`).
      const dejarDeApuntar = alDejarDeMandar(self, function() {
        self.cargandoTipos = false;
      });
      RhBandejaVacaciones.tiposAnulacion()
        .then(function(tipos) {
          if (!sigueSiendoMia()) return;
          self.tipos = tipos || [];
        })
        .catch(function() {
          if (!sigueSiendoMia()) return;
          self.tipos = [];
        })
        .then(function() {
          // La baja va SIEMPRE y primero: lo que ya ha terminado no tiene nada que soltar, y
          // dejarlo apuntado apagaría el «cargando» de la consulta siguiente en la salida de
          // después. Quita solo lo que apuntó esta consulta, no lo de la nueva.
          dejarDeApuntar();
          if (!sigueSiendoMia()) return;
          self.cargandoTipos = false;
        });
    },
    esAnulable: function(dia) {
      return this.anulables.indexOf(dia) >= 0;
    },
    alternar: function(dia, marcado) {
      const i = this.elegidos.indexOf(dia);
      if (marcado && i < 0) this.elegidos.push(dia);
      if (!marcado && i >= 0) this.elegidos.splice(i, 1);
    },
    /**
     * **La anulación sale por la puerta del módulo** (`accionDeLaSesion`), la misma de aprobar,
     * denegar y resolver una anulación desde la bandeja, y por los mismos cuatro motivos que
     * explica `pedir-anulacion.vue`. Aquí hay además un diálogo por medio, y eso es la mitad del
     * motivo:
     *
     * entre el «Anular» y el «Sí» hay una persona, y ese rato no tiene tope. Con el `confirm` a
     * secas, cerrar sesión con el diálogo abierto y aceptar después mandaba la anulación de la
     * persona que había elegido la cuenta anterior **con el token de la nueva** —y si quien entraba
     * también podía anular, el servidor la aceptaba—. `confirmar` sella el diálogo con la sesión
     * de cuando se abrió, que es la regla que fijó dirección el 07/10/2026 en la #59.
     *
     * El preloader también deja de ser un `show()`/`hide()` directo: el que había se apagaba en el
     * `then` final, después de que `anulada` hubiera arrancado dos recargas, así que la pantalla
     * volvía a parecer lista enseñando los datos de antes.
     */
    anular: function() {
      const self = this;
      const app = self.$f7;
      // **Todo lo que se va a mandar, tomado ANTES de abrir el diálogo**, que es lo que el diálogo
      // enseña. Leerlo de la ventana al aceptar mezclaba dos solicitudes si en medio se reabría
      // sobre otra: los días eran de la primera y la solicitud, el tipo y el motivo de la segunda
      // (revisión CODEX del PR #1748, ronda 2 del 20/10). `accionDeLaSesion` ya no acepta un
      // diálogo de una ventana reabierta; esto es lo que hace que, aunque lo aceptara, mandase
      // lo que se confirmó. Es lo mismo que hacen la bandeja, el calendario y «Registrar en
      // nombre de otra persona» (`accion.datos`).
      const s = self.solicitud;
      const anulacion = {
        id: s.id,
        version: s.version,
        codigo: s.codigo,
        quien: self.nombre,
        dias: s.dias.filter(function(dia) { return self.elegidos.indexOf(dia) >= 0; }),
        tipo: self.tipo,
        motivo: self.motivo.trim()
      };
      const dias = anulacion.dias;
      const accion = accionDeLaSesion(self, claveDeSolicitud(anulacion.id));
      // Se confirma: quita días del calendario de otra persona y los borra de la base de datos.
      accion.confirmar(
        self.$t('anularVacaciones.confirmaAnular', {
          n: dias.length, quien: anulacion.quien, codigo: anulacion.codigo
        }),
        self.$t('anularVacaciones.anularTitulo', { quien: anulacion.quien }),
        function() {
          accion.enviar(
            RhBandejaVacaciones.anularDirectamente(anulacion.id, anulacion.version, dias,
              anulacion.tipo, anulacion.motivo),
            {
              // **El acuse y el cierre son de ESTA ventana**, y por eso van en `exito`: si se
              // cierra con el POST en vuelo y se abre sobre otra persona, el nombre que se pinta y
              // el formulario que se cierra ya serían los de ella —el acuse le atribuía los días
              // anulados de la primera y el cierre se llevaba por delante lo que estuviera
              // escribiendo (revisión CODEX del PR #1748, ronda 9)—. `accionDeLaSesion` lo
              // descarta por el sello de la ventana; y el nombre es además el que se tomó al abrir
              // el diálogo, el de la persona cuya anulación se envió.
              exito: function() {
                app.toast.create({
                  text: self.$t('anularVacaciones.anuladas', { n: dias.length, quien: anulacion.quien }),
                  position: 'center', closeTimeout: 3000
                }).open();
                self.$emit('cerrar');
              },
              fallo: function(e) {
                // Un intento repetido cortado por el adaptador, o una respuesta de otra sesión, no
                // se le cuentan a quien esté delante: ni el error ni el nombre de la persona que
                // gestionaba la cuenta anterior.
                if (RhBandejaVacaciones.sinNadaQueDecir(e)) return;
                app.dialog.alert(mensajeDelServidor(e, self.$t('anularVacaciones.errorAnulando')));
              },
              // **La recarga es de la PANTALLA y no de esta ventana**, así que sobrevive a
              // cerrarla: los días ya no están, y dejar la rejilla con ellos puestos hasta que
              // alguien pulse «Recargar» es la misma mentira que el contador de antes. Lo que no
              // hace ya es cerrar la ventana —eso es `exito`, de la ventana—, para que no cierre la
              // de la persona que se esté mirando ahora.
              pantalla: function() {
                self.$emit('anulada');
              },
              // **El badge del menú no es de esta pantalla, así que va en `fuera` y no en `exito`**
              // —lo mismo que ya hacen la bandeja y el calendario al resolver—. Si esos días
              // estaban en una petición de anulación pendiente, el servidor la cierra y el número
              // baja; el menú lateral se monta una vez en su vista persistente y solo se entera por
              // este aviso. Colgado de `exito`, bastaba con que quien anuló se fuera de Vacaciones
              // antes de que contestara el POST para que el contador se quedara con el de antes el
              // resto de la sesión (revisión CODEX del PR #1748, ronda 8): la anulación ocurrió, y
              // haberse ido de la pantalla no la deshace.
              fuera: function() {
                EventBus.$emit(EVENTO_VACACIONES_RESUELTA);
              }
            }
          );
        }
      );
    },
    /**
     * Cualquiera de las salidas del módulo —las tres de la pantalla y la de la ventana—. Al cerrar
     * sesión se tira lo escrito —los días, el tipo y el motivo son de quien los estaba
     * escribiendo— y también la lista de tipos: es una lista que el servidor sirve por sesión y
     * volver a pedirla es una petición.
     *
     * Con `MOTIVO_OTRA_VENTANA` no hay nada que tirar: lo escrito lo limpia `abrir()` en la
     * apertura siguiente, y la lista de tipos es la misma para toda la sesión.
     *
     * Lo que **no** está aquí es soltar la espera de esa lista: lo apunta `cargarTipos` con
     * `alDejarDeMandar`, que corre en las tres salidas y no solo al cerrar sesión, y así lo suelta
     * quien lo cogió. Puesto aquí, vaciar `tipos` sin soltar `cargandoTipos` era justamente lo que
     * dejaba la ventana en «cargando…» para siempre si la consulta no volvía.
     *
     * El cerrojo de la solicitud no se suelta aquí, por lo mismo que en «Pedir anulación».
     */
    dejarDeMandar: function(motivo) {
      if (motivo === MOTIVO_CIERRE_DE_SESION) {
        this.elegidos = [];
        this.tipo = '';
        this.motivo = '';
        this.tipos = [];
      }
    },
    fechasDe: function(solicitud) {
      const self = this;
      return textoDeLasFechas(solicitud, function(iso) { return self.corta(iso); });
    },
    /** «13 oct», sin pasar por `Date`: un `LocalDate` se movería de día con la zona del navegador. */
    corta: function(iso) {
      if (!iso) return '';
      const trozos = String(iso).substring(0, 10).split('-');
      if (trozos.length !== 3) return String(iso);
      return parseInt(trozos[2], 10) + ' ' + this.$t('misVacaciones.mes_' + parseInt(trozos[1], 10));
    }
  }
};
</script>
